import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaBuilding,
  FaPhoneAlt,
  FaEnvelope
} from 'react-icons/fa';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  // Light blue color that will pop against dark background
  const linkColor = '#60A5FA'; // This is a bright light blue

  return (
    <footer style={{ backgroundColor: '#1E293B', color: 'white', padding: '3.5rem 0 1.5rem 0' }}>
      <Container>
        <Row className="gy-4">
          <Col lg={4} md={12} className="mb-3 mb-lg-0">
            <h2 className="h4 mb-3 fw-bold text-white">Telering Process Pvt. Ltd.</h2>
            <p className="mb-4" style={{ color: '#CBD5E1', lineHeight: '1.6' }}>
              Empowering businesses with ready-to-use office essentials—from ergonomic furniture to high-performance tech. Your workspace, streamlined.
            </p>
            <div className="social-links d-flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: linkColor }} aria-label="Facebook">
                <FaFacebook size={22} className="hover-brighten" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ color: linkColor }} aria-label="Twitter">
                <FaTwitter size={22} className="hover-brighten" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: linkColor }} aria-label="Instagram">
                <FaInstagram size={22} className="hover-brighten" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: linkColor }} aria-label="LinkedIn">
                <FaLinkedin size={22} className="hover-brighten" />
              </a>
            </div>
          </Col>

          <Col lg={3} md={4} sm={6}>
            <h3 className="h5 mb-3 fw-semibold text-white">Quick Links</h3>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/products" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten">
                  Products
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/solutions" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten">
                  Solutions
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/bulk-orders" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten">
                  Custom Packages
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten">
                  Contact Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy-policy" style={{ color: linkColor, textDecoration: 'none' }} className="hover-brighten fw-semibold">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </Col>

          <Col lg={5} md={8} sm={12}>
            <h3 className="h5 mb-3 fw-semibold text-white">Contact &amp; Locations</h3>
            <div className="mb-3 d-flex flex-wrap gap-3">
              <a
                href="tel:+919801426752"
                className="d-flex align-items-center text-decoration-none hover-brighten"
                style={{ color: '#E2E8F0', fontSize: '0.92rem' }}
              >
                <FaPhoneAlt size={14} className="me-2" style={{ color: linkColor }} />
                <span>+91 98014 26752</span>
              </a>
              <a
                href="mailto:support@teleringprocess.in"
                className="d-flex align-items-center text-decoration-none hover-brighten"
                style={{ color: '#E2E8F0', fontSize: '0.92rem' }}
              >
                <FaEnvelope size={14} className="me-2" style={{ color: linkColor }} />
                <span>support@teleringprocess.in</span>
              </a>
            </div>

            {/* Highlighted Address Card */}
            <div
              className="p-3 rounded-3"
              style={{
                background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(37, 99, 235, 0.15) 100%)',
                border: '1.5px solid rgba(96, 165, 250, 0.55)',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(8px)'
              }}
            >


              {/* Branch Office Address */}
              <div className="pt-2" style={{ borderTop: '1px dashed rgba(96, 165, 250, 0.3)' }}>
                <div className="d-flex align-items-center mb-1">
                  <FaBuilding style={{ color: '#60A5FA', fontSize: '1.05rem' }} className="me-2" />
                  <span
                    className="fw-bold px-2 py-0.5 rounded"
                    style={{
                      color: '#93C5FD',
                      backgroundColor: 'rgba(59, 130, 246, 0.2)',
                      fontSize: '0.78rem',
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase'
                    }}
                  >
                    Branch Office
                  </span>
                </div>
                <p className="mb-0 ps-4" style={{ color: '#F1F5F9', fontSize: '0.88rem', lineHeight: '1.45' }}>
                  78 Bentick Street, 3rd Floor, 3B/9, Krishna Square,<br />
                  Kolkata – 700001, West Bengal, India.
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="my-4" style={{ borderColor: 'rgba(255, 255, 255, 0.12)' }} />

        {/* Subfooter */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center small">
          <p className="mb-2 mb-md-0" style={{ color: '#94A3B8' }}>
            &copy; {new Date().getFullYear()} Telering Process Pvt. Ltd. All rights reserved.
          </p>
          <div className="d-flex gap-3">
            <Link to="/privacy-policy" style={{ color: '#94A3B8', textDecoration: 'none' }} className="hover-brighten">
              Privacy Policy
            </Link>
            <span style={{ color: '#475569' }}>|</span>
            <Link to="/contact" style={{ color: '#94A3B8', textDecoration: 'none' }} className="hover-brighten">
              Contact Us
            </Link>
          </div>
        </div>

        <style jsx>{`
          .hover-brighten {
            transition: all 0.2s ease-in-out;
          }
          .hover-brighten:hover {
            filter: brightness(1.25);
            text-decoration: underline;
          }
        `}</style>
      </Container>
    </footer>
  );
};

export default Footer;
